// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ambient-backdrop {
  position: fixed;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
  background-color: var(--bg-base);
}

/* Mood wash over the neutral base — fades fully before a hard horizon. */
.ambient-tint {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(120% 80% at 50% -8%, var(--mood-tint) 0%, transparent 68%),
    linear-gradient(180deg, var(--mood-tint) 0%, transparent 58%);
  transition: background 0.7s ease;
}

.ambient-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  transition: background-color 0.7s ease;
  will-change: transform;
}

.ambient-glow--1 {
  width: 46vw;
  min-width: 380px;
  aspect-ratio: 1;
  top: -12vh;
  right: -6vw;
  background-color: var(--mood-glow-1);
  animation: ambient-drift-a 26s ease-in-out infinite;
}

.ambient-glow--2 {
  width: 40vw;
  min-width: 320px;
  aspect-ratio: 1;
  top: 6vh;
  left: -10vw;
  background-color: var(--mood-glow-2);
  animation: ambient-drift-b 32s ease-in-out infinite;
}

.ambient-glow--3 {
  width: 42vw;
  min-width: 300px;
  aspect-ratio: 1;
  top: auto;
  bottom: -18vh;
  left: 28%;
  background-color: var(--mood-glow-3);
  animation: ambient-drift-c 38s ease-in-out infinite;
}

/* Softens the lower third without a hard band across the screen */
.ambient-vignette {
  position: absolute;
  inset: 0;
  background: radial-gradient(
    140% 90% at 50% 110%,
    color-mix(in srgb, var(--bg-base) 45%, transparent) 0%,
    transparent 55%
  );
}

@keyframes ambient-drift-a {
  0%, 100% { transform: translate3d(0, 0, 0); }
  50% { transform: translate3d(-4vw, 4vh, 0); }
}

@keyframes ambient-drift-b {
  0%, 100% { transform: translate3d(0, 0, 0); }
  50% { transform: translate3d(3vw, -3vh, 0); }
}

@keyframes ambient-drift-c {
  0%, 100% { transform: translate3d(0, 0, 0); }
  50% { transform: translate3d(-3vw, -4vh, 0); }
}

@media (max-width: 768px) {
  .ambient-glow {
    filter: blur(72px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .ambient-glow {
    animation: none !important;
  }

  .ambient-tint,
  .ambient-glow {
    transition: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AmbientBackdrop/AmbientBackdrop.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,QAAQ;EACR;;iEAE+D;EAC/D,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,WAAW;EACX,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;GAIC;AACH;;AAEA;EACE,WAAW,+BAA+B,EAAE;EAC5C,MAAM,oCAAoC,EAAE;AAC9C;;AAEA;EACE,WAAW,+BAA+B,EAAE;EAC5C,MAAM,oCAAoC,EAAE;AAC9C;;AAEA;EACE,WAAW,+BAA+B,EAAE;EAC5C,MAAM,qCAAqC,EAAE;AAC/C;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;AACF","sourcesContent":[".ambient-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 0;\n  overflow: hidden;\n  pointer-events: none;\n  background-color: var(--bg-base);\n}\n\n/* Mood wash over the neutral base — fades fully before a hard horizon. */\n.ambient-tint {\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(120% 80% at 50% -8%, var(--mood-tint) 0%, transparent 68%),\n    linear-gradient(180deg, var(--mood-tint) 0%, transparent 58%);\n  transition: background 0.7s ease;\n}\n\n.ambient-glow {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(100px);\n  transition: background-color 0.7s ease;\n  will-change: transform;\n}\n\n.ambient-glow--1 {\n  width: 46vw;\n  min-width: 380px;\n  aspect-ratio: 1;\n  top: -12vh;\n  right: -6vw;\n  background-color: var(--mood-glow-1);\n  animation: ambient-drift-a 26s ease-in-out infinite;\n}\n\n.ambient-glow--2 {\n  width: 40vw;\n  min-width: 320px;\n  aspect-ratio: 1;\n  top: 6vh;\n  left: -10vw;\n  background-color: var(--mood-glow-2);\n  animation: ambient-drift-b 32s ease-in-out infinite;\n}\n\n.ambient-glow--3 {\n  width: 42vw;\n  min-width: 300px;\n  aspect-ratio: 1;\n  top: auto;\n  bottom: -18vh;\n  left: 28%;\n  background-color: var(--mood-glow-3);\n  animation: ambient-drift-c 38s ease-in-out infinite;\n}\n\n/* Softens the lower third without a hard band across the screen */\n.ambient-vignette {\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(\n    140% 90% at 50% 110%,\n    color-mix(in srgb, var(--bg-base) 45%, transparent) 0%,\n    transparent 55%\n  );\n}\n\n@keyframes ambient-drift-a {\n  0%, 100% { transform: translate3d(0, 0, 0); }\n  50% { transform: translate3d(-4vw, 4vh, 0); }\n}\n\n@keyframes ambient-drift-b {\n  0%, 100% { transform: translate3d(0, 0, 0); }\n  50% { transform: translate3d(3vw, -3vh, 0); }\n}\n\n@keyframes ambient-drift-c {\n  0%, 100% { transform: translate3d(0, 0, 0); }\n  50% { transform: translate3d(-3vw, -4vh, 0); }\n}\n\n@media (max-width: 768px) {\n  .ambient-glow {\n    filter: blur(72px);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ambient-glow {\n    animation: none !important;\n  }\n\n  .ambient-tint,\n  .ambient-glow {\n    transition: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
